import {Deserializable} from "./deserializable.model";

export class SubjectService {

subject_service_id?: number;
subject_id?: number;
job_id?: number;
subject_service_method_id?: number;
fellow_occupants_name?: string;
fellow_occupants_relationship?: string;
fellow_occupants_sex?: string;
authorised_employee_name?: string;
authorised_employee_job_title?: string;
authorised_employee_sex?: string;
office_business_name?: string;
exact_service_method?: string;
created_by?: number;
created_date?: string;
date_service?: Date;
time_service?: Date;
who_service?: number;
subject_service_outcome_id?: number;
address_1?: string;
address_2?: string;
state?: string;
postcode?: string;
country?: string;
suburb?: string;
new_address?: string;
new_address_1?: string;
new_address_2?: string;
new_state?: string;
new_postcode?: string;
new_country?: string;
new_suburb?: string;
subject_location_status_id?: number;
subject_location_status_found_id?: number;
vehicles?: string;
neighbours?: string;
calling_card?: string;
postal_mail?: string;
phone_call?: string;
attempts?: string;
person_type?: string;
person_spoken_with?: string;
person_spoken_with_advised?: string;
business_name?: any;
new_business_name?: string;
service_number?: number;
subject_attempt_type_id?: number;
vehicles_notes?: string;
neighbours_notes?: string;
calling_card_notes?: string;
postal_mail_notes?: string;
attempts_notes?: string;
phone_call_notes?: string;

subject_name?: string;
subject_number?: string;
subject_service_method_name?: string;
fellow_occupants_relationship_name?: string;
exact_service_method_name?: string;
subject_service_outcome_name?: string;
who_service_name?: string;
subject_location_status_name?: string;
subject_location_status_found_name?: string;
location_status_found_name?: string;

address_full?: string; // all as one
new_address_full?: string;

file_number?: number;
reference_number?: number;
last_insert_id?: any;

send_communications?: any;
   brand_report_id?: any;
   brand_invoice_id?: any;


//  July 2022 Additial affidavit and service methods and types additions

subject_service_method_true_id: number; // created as the API converts the real ID to a name when pulling in some functions/hard coded.
subject_service_outcome_true_id: number; // created as the API converts the real ID to a name when pulling in some functions/hard coded.
// withness
witness_name?: string;
witness_business_name?: string;
witness_address_1?: string;
witness_address_2?: string;
witness_state?: string;
witness_postcode?: string;
witness_country?: string;
witness_suburb?: string;

person_in_charge_of_prison_name?: string;
person_in_charge_of_prison_occupation?: string;

subject_contact_email_id?: number;
email_address_served?: string; // 
director_name?: string; //
service_under_order?: string;

service_file_array?;
general_notes?: string;
email_contents?: string;
phone_number?: string;
subject_contact_number_id?: number;
// count or not, based on service_outcome_ method is_count choice.
is_count?: number;

// Drive By and occupancy.
property_images?: any; // array_name and holder
attach_file_array_name?: any; // set if passed
property_occupied?: string;

property_occupied_details?: string;
property_type_id?: number;
property_type_name?: string;
property_type_details?: string;
property_type_images?: any; // array_name and holder


property_forsale_or_lease_sign?: string;
property_sign_images?: any;
property_forsale_or_lease_sign_details?: string;

// property_sign_field_meta?: any[];
property_sign_field_meta?: any;

property_agent_name?: string;
property_agency_name?: string;
property_agency_contact_numbers?: string;


property_mail?: string;
property_mail_images: any;
property_mail_details?: string;

property_vehicles_sighted?: string;
property_vehicles_sighted_details?: string;
property_vehicles_images
property_v_make?: string;
property_v_model?: string;
property_v_plate?: string;
property_v_rego_state?: string;

property_pets?: string;
property_pets_details?: string;
property_pets_images?: any;


property_occupancy?: string;
property_occupancy_details?: string;
property_occupancy_images: any;

property_o_name?: string;
property_o_contact_numbers?: string;
property_o_lease_details?: string;
property_o_lease_date?: string;
property_o_landlord_contacts?: string;

property_condition?: string;
property_condition_images?: any;






  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectService {
    Object.assign(this, input);

    return this;
  }


}
